import React from "react";
import { FALLBACK_IMG_ALT } from "../../constants/fallback";
import FALLBACK_IMG from "../../assets/images/default-thumb.png";

const FallBackImg = () => {
  return (
    <img
      src={FALLBACK_IMG}
      alt={FALLBACK_IMG_ALT}
      style={{ width: "100%", opacity: 0.7, borderRadius: "8px" }}
      loading="lazy"
    />
  );
};

export default FallBackImg;
